export default {
    name: 'profile-tabs-menu',
    components: {},
    props: ["user_role", "can_see_consultation", "consultationEnCours", "can_see_atcd"],
    data() {
        return {
            // can_see_atcd: false,
        }
    },
    computed: {
        
    },
    mounted() {
        // if (this.consultationEnCours.tarif_consultation) {

        //     if (
        //         this.consultationEnCours.tarif_consultation.type_consultation.nom != 'Consultation Néonatologique' && 
        //         this.consultationEnCours.tarif_consultation.type_consultation.nom != 'Consultation d\'allergologie' && 
        //         this.consultationEnCours.tarif_consultation.type_consultation.nom != 'Consultation Pédiatrique'
        //     ) {
        //         this.can_see_atcd = true
        //     }
        // }

        
    },
    methods: {
        changeTab(tab0, tab1) {
            this.$emit('changingTab', tab0, tab1)
        }
    }
}